import { Box, useToken } from '@chakra-ui/react';
import type { FC } from 'react';
import FaceliftDialog from '@/components/Atoms/FaceliftDialog';
import { FaceliftPdfViewerContainer } from '../FaceliftPdfViewerContainer/FaceliftPdfViewerContainer';

export type Item = { id: string; content: string; secondaryContent?: string };
export type Column = { id: string; title: string; itemIds: string[] };
export type Board = {
	item: Record<string, Item>;
	columns: Record<string, Column>;
	columnOrder: string[];
};

export interface FaceliftInvoiceViewPDFProps {
	viewInvoiceModal: boolean;
	isLoading?: boolean;
	pdfViewerUrl: string;
	onOpenChange: () => void;
	isEmptyOrUnavailable?: boolean;
	isLoadError?: boolean;
}

const FaceliftInvoiceViewPDF: FC<FaceliftInvoiceViewPDFProps> = ({
	viewInvoiceModal = false,
	isLoading = false,
	pdfViewerUrl,
	onOpenChange,
	isEmptyOrUnavailable,
	isLoadError,
}) => {
	const [brand600] = useToken('colors', ['brand.600']);

	return (
		<Box>
			{/* This Dialog is used to view a single invoice PDF (from table link click) */}
			<FaceliftDialog
				open={viewInvoiceModal}
				showBackBtn={true}
				onOpenChange={onOpenChange}
				title="View Invoice"
				size="xl"
				sx={{ boxShadow: `0 0 20px 0px ${brand600}` }}
			>
				<FaceliftPdfViewerContainer
					isLoading={isLoading}
					url={pdfViewerUrl}
					isEmptyOrUnavailable={isEmptyOrUnavailable}
					isLoadError={isLoadError}
				/>
			</FaceliftDialog>
		</Box>
	)
};

export default FaceliftInvoiceViewPDF;
